export const participants: TableModule = {
    name: "participants",
    route: "spa.events.events.participants",
    routeParams: [{
        param: "event",
        prop: "event_id"
    }],
    defaultOrder: {
        column: "lastname",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            mobile: true,
            truncate: false,
            pageLink: true
        },
        {
            name: "gender",
            truncate: false,
            sortable: true,
            width: 'w-[120px]',
            breakpoint: 'lg'
        },
        {
            name: "address",
            sortable: true,
            sortBy: "participants.zip",
        },
        {
            name: "participantGroups",
            truncate: false,
            breakpoint: 'md'
        },
        {
            name: "communications",
            breakpoint: 'lg'
        },
        {
            name: "created_at",
            sortable: true,
            width: 'w-[150px]',
            breakpoint: 'lg'
        },
        {
            name: "status",
            // Narrow on phones so the icons wrap into rows and the name keeps its width.
            width: 'w-[128px] md:w-[220px]',
            truncate: false,
            mobile: true,
        }
    ],
    filters: [
        {
            name: "id",
            column: "participants.id",
            type: "numeric"
        },
        {
            name: "firstname",
            column: "participants.firstname",
            type: "string"
        },
        {
            name: "lastname",
            column: "participants.lastname",
            type: "string",
            reduced: true
        },
        {
            name: "birthday",
            column: "participants.birthday",
            type: "date",
            reduced: "date[,]"
        },
        {
            name: "gender",
            column: "participants.gender",
            type: "select",
            options: () => ['m', 'f', 'd'].map((option) => ({
                value: option,
                label: useNuxtApp().$i18n.t(`genders.${option}`)
            }))
        },
        {
            name: "street",
            column: "participants.street",
            type: "string"
        },
        {
            name: "house_number",
            column: "participants.house_number",
            type: "string"
        },
        {
            name: "zip",
            column: "participants.zip",
            type: "string",
            reduced: true
        },
        {
            name: "city",
            column: "participants.city",
            type: "string"
        },
        {
            name: "email",
            column: "participants.email",
            type: "string"
        },
        {
            name: "submission",
            column: "participants.submission_id",
            type: "exists"
        },
        {
            name: "teamer",
            column: "participants.teamer",
            type: "boolean"
        },
        {
            name: "cancelled",
            column: "participants.cancelled",
            type: "boolean"
        },
        {
            name: "reminders_blocked",
            column: "participants.reminders_blocked",
            type: "boolean"
        },
        {
            name: "pass_sent",
            column: "participants.pass_sent_at",
            type: "exists"
        },
    ],
    quickFilters: [
        {
            name: "qf_onlyWithSubmission",
            column: "participants.submission_id",
            value: true,
            operator: "exists"
        },
        {
            name: "qf_onlyWithoutSubmission",
            column: "participants.submission_id",
            value: false,
            operator: "exists"
        },
        {
            name: "qf_onlyWithoutPassSent",
            column: "participants.pass_sent_at",
            value: false,
            operator: "exists"
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "participants"]
        },
        {
            name: "participants.sendLinks",
            color: "yellow",
            ability: ["update", "participants"]
        },
        {
            name: "participants.blockReminders",
            color: "rose",
            ability: ["update", "participants"]
        },
        {
            name: "participants.assignGroups",
            color: "cyan",
            ability: ["update", "participants"]
        },
        {
            name: "general.export"
        }
    ]
}